// Los resúmenes en texto del modal de guardado (mockup: "3 KPI · comparación · distribución ·
// evolución", "Últimos 14 días · comparado con el período anterior"). Puros, sin React.

import {PANEL_TYPES} from '../state/informeModel';
import {getPeriodName} from '../../../periods';

// El rótulo de esa fila dice de QUÉ se habla: con la fuente en líneas decía «Cuentas · 1 línea de
// seguimiento» (QA-VIS-SEGFE-18).
export function accountsLabel(settings, t) {
    return settings.source_type === 'BUSINESS_UNITS'
        ? t('informes.save.lines', 'Líneas de seguimiento')
        : t('informes.save.accounts', 'Cuentas');
}

export function accountsSummary(settings, t) {
    const n = (settings.selected_items || []).length;
    const isBu = settings.source_type === 'BUSINESS_UNITS';
    if (n === 0) return isBu ? t('informes.save.all_lines', 'Todas las líneas de seguimiento') : t('informes.save.all_accounts', 'Todas las cuentas');
    return isBu
        ? t('informes.save.lines_count', {count: n, defaultValue: '{{count}} líneas de seguimiento'})
        : t('informes.save.accounts_count', {count: n, defaultValue: '{{count}} cuentas'});
}

export function periodLabel(period, t) {
    if (!period) return '';
    if (period.type === 'FIXED') return `${period.start_date} – ${period.end_date}`;
    return getPeriodName(period.predefined_period, t) || period.predefined_period || '';
}

export function periodSummary(settings, t) {
    const parts = [periodLabel(settings.period, t)];
    if (settings.compare) {
        const cmp = settings.compare_period && settings.compare_period.predefined_period === 'SAME_PERIOD_LAST_YEAR'
            ? t('informes.save.compared_last_year', 'comparado con el mismo período del año anterior')
            : t('informes.save.compared_previous', 'comparado con el período anterior');
        parts.push(cmp);
    }
    const filters = (settings.dimensions_filters || []).flat().length;
    if (filters > 0) parts.push(t('informes.save.filters_count', {count: filters, defaultValue: '{{count}} filtros'}));
    return parts.filter(Boolean).join(' · ');
}

export function fieldsSummary(template, t) {
    const n = (template.fields || []).length;
    return t('informes.save.fields_count', {count: n, defaultValue: '{{count}} seleccionadas · definen la tabla y los gráficos'});
}

export function panelsSummary(template, t) {
    const panels = template.panels || [];
    const kpis = panels.filter((p) => p.type === PANEL_TYPES.KPI).length;
    const parts = [];
    if (kpis) parts.push(t('informes.save.kpi_count', {count: kpis, defaultValue: '{{count}} KPI'}));
    if (panels.some((p) => p.type === PANEL_TYPES.BARS)) parts.push(t('informes.save.has_bars', 'comparación'));
    if (panels.some((p) => p.type === PANEL_TYPES.PIE)) parts.push(t('informes.save.has_pie', 'distribución'));
    if (panels.some((p) => p.type === PANEL_TYPES.LINE)) parts.push(t('informes.save.has_line', 'evolución'));
    if (panels.some((p) => p.type === PANEL_TYPES.TABLE)) parts.push(t('informes.save.has_table', 'tabla'));
    const texts = panels.filter((p) => p.type === PANEL_TYPES.TEXT).length;
    if (texts) parts.push(t('informes.save.text_count', {count: texts, defaultValue: '{{count}} textos'}));
    return parts.length ? parts.join(' · ') : t('informes.save.no_panels', 'Sin gráficos');
}
